import { PricingSchemeApplyFilterType } from "../../graphql/types/PricingSchemeApplyType";

export const DSPPricingSchemeApplyFilterInitialValue: PricingSchemeApplyFilterType = {
    pricingSchemeId: undefined,
    bindTime: null,
    effectiveTime: null,
    operatorId: undefined,
    activeStatus: undefined,
    bindValue: undefined,
    businessScenario: null,
    timezone: 'Asia/Shanghai',
};

export const activeStatusOptions = [
    { label: '生效中', value: '1' },
    { label: '已失效', value: '0' },
    { label: '待生效', value: '2' },
];

/** IANA 时区选项（Apply Price 仅支持 Asia/Shanghai、America/Los_Angeles） */
export const timezoneOptions = [
    { label: 'Asia/Shanghai', value: 'Asia/Shanghai' },
    { label: 'America/Los_Angeles', value: 'America/Los_Angeles' },
];
